import { Navigate, Outlet } from 'react-router-dom'

import { paths } from '@/app/router/paths'
import { useCanEditCatalogue } from '@/features/platform/hooks/useCanEditCatalogue'

/**
 * Sits under the tenant `AreaRoute`. A session without `CATALOG_EDIT` is sent
 * to the pipeline: the server refuses it every catalogue request, so the page
 * would be nothing but an error.
 */
export function CatalogueRoute() {
  const canEditCatalogue = useCanEditCatalogue()

  if (!canEditCatalogue) return <Navigate to={paths.pipeline} replace />

  return <Outlet />
}
